export default __webpack_public_path__ + "static/media/Whale.b7890752.svg";